<template>
  <v-card light>
    <v-card-subtitle class="blue white--text pa-1 text-center">
      <v-row>
        <v-col cols="6" class="pt-1">{{ title }}</v-col>
        <v-col cols="3" class="pa-0">
          <v-switch v-model="muted" class="ma-0" color="warning">
            <template v-slot:label>
              <v-icon class="mdi mdi-volume-off white--text"></v-icon>
            </template>
          </v-switch>
        </v-col>
        <v-col cols="3" class="pa-0">
          <v-switch v-model="question" class="ma-0" color="warning">
            <template v-slot:label>
              <v-icon class="mdi mdi-account-question white--text"></v-icon>
            </template>
          </v-switch>
        </v-col>
      </v-row>
    </v-card-subtitle>

    <v-card height="250" class="scroll">
      <v-container id="scrollpane">
        <v-row
          v-for="(msg, index) in messages"
          :justify="msg.myself ? 'end' : 'start'"
          :key="index"
          class="pa-1"
        >
          <v-col
            cols="10"
            class="text-left balloon pa-1"
            v-bind:class="{ bg0: msg.myself, bg1: !msg.myself }"
          >
            <pre>{{ msg.text }}</pre>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card-actions>
      <v-textarea
        @keydown="keydown"
        rows="1"
        v-model="input"
        hide-details
        dense
        label="Type message..."
      ></v-textarea>
      <v-btn text @click="send" id="send">send</v-btn>
    </v-card-actions>
    <audio id="bell" src="@/assets/bell.wav" />
  </v-card>
</template>

<script>
export default {
  props: ["title", "message"],
  data() {
    return {
      input: null,
      messages: [],
      question: false,
      muted: false,
    };
  },
  methods: {
    keydown(e) {
      if (e.keyCode == 13) {
        if (e.ctrlKey == false && e.altKey == false) {
          this.send();
          e.preventDefault();
        }
      }
    },
    send() {
      if (this.input == "") {
        return;
      }
      this.$emit("chatSend", this.input);
      this.messages.push({ myself: true, text: this.input });
      this.input = "";
      this.scroll();
    },
    scroll() {
      this.$nextTick().then(
        () => {
          var obj = document.getElementById("scrollpane");
          if (obj) {
            obj.parentElement.scroll(0, obj.scrollHeight);
          }
        },
        (e) => {
          console.log(e);
        }
      );
    },
  },
  watch: {
    message(s) {
      var bell = document.getElementById("bell");
      bell.volume = 0.1;
      bell.currentTime = 0;
      bell.play();
      if (s == "question-on") {
        this.question = true;
      } else if (s == "question-off") {
        this.question = false;
      } else {
        this.messages.push({ myself: false, text: s });
        this.scroll();
      }
    },
    question(v) {
      if (v) {
        this.$emit("chatSend", "question-on");
      } else {
        this.$emit("chatSend", "question-off");
      }
    },
    muted(v){
      this.$emit("muted", v);
    }
  },
};
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}
.balloon {
  border: solid 1px #eee;
  border-radius: 5px;
}
.bg0 {
  background-color: #bef18c;
}
.bg1 {
  background-color: #eee;
}
</style>
